import * as React from "react";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";


function StylesheetProvider(props: React.PropsWithChildren) {
    return (
        <StyleSheetManager shouldForwardProp={shouldForwardProp} enableVendorPrefixes>
            {props.children}
        </StyleSheetManager>
    )
}

// https://styled-components.com/docs/faqs#what-do-i-need-to-do-to-migrate-to-v6
// This implements the default behavior from styled-components v5
export function shouldForwardProp(propName: string, target: any) {
    if (typeof target === "string") {
        // For HTML elements, forward the prop if it is a valid HTML attribute
        return isPropValid(propName);
    }
    // For other elements, forward all props
    return true;
}


export default StylesheetProvider;